<template>
  <div class="d-flex align-center flex-column mobile-container">
    <v-row
      v-for="(item, index) in accordionData"
      class="d-flex flex-column mobile-section"
      :key="index"
      :ref="'section' + index"
    >
      <div class="inner-content">
        <div class="content-header" @click="accordionSection(index)">
          <span class="mobile-title" v-html="item.title"></span>
          <v-icon>{{
            activeSection === index ? icons.mdiMinus : icons.mdiPlus
          }}</v-icon>
        </div>
        <transition name="slide-fade" @after-enter="handleTransitionEnd(index)">
          <div v-if="activeSection === index" class="content-container">
            <div class="content-image">
              <v-img
                v-if="accordionData[index].content.image"
                class="content-image"
                :src="accordionData[index].content.image"
                contain
              />
            </div>
            <Accordion
              v-if="accordionSubData && index === 1"
              :accordionData="accordionSubData"
            />
            <div v-else class="content-text">
              <div class="mb-4">
                <span class="content-title" v-html="item.title"></span>
              </div>
              <div class="content-paragraphs" v-html="item.content.text"></div>
            </div>
            <div class="button-container" v-if="item.content.buttonText">
              <GradientButton
                :title="item.content.buttonText"
                @gradientButtonClicked="
                  handleButtonClick(item.content.buttonUrl)
                "
              />
            </div>
          </div>
        </transition>
      </div>
    </v-row>
  </div>
</template>

<script>
import { mdiMinus, mdiPlus } from "@mdi/js";
import Accordion from "../../common/Accordion.vue";
export default {
  name: "TabbedContent",
  components: {
    Accordion,
  },
  data() {
    return {
      activeSection: 0,
      placeholder: require(`@/assets/shared/redesign/common/placeholder.svg`),
      howItWorksData: null,
      easyUpdatesContent: null,
      icons: {
        mdiMinus: mdiMinus,
        mdiPlus: mdiPlus,
      },
    };
  },
  props: {
    accordionData: {
      required: true,
      default: [],
      type: Array,
    },
    accordionSubData: {
      required: false,
      type: Array,
    },
  },
  created() {},
  methods: {
    getActiveTab(index) {
      return this.activeTab === index;
    },
    accordionSection(index) {
      this.activeSection = this.activeSection === index ? null : index;
    },
    handleTransitionEnd(index) {
      this.$nextTick(() => {
        if (this.activeSection === index) {
          const section = this.$refs["section" + index][0];
          if (section) {
            this.$refs["section" + index][0].scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }
      });
    },
    handleButtonClick(url) {
      if (url === "EstateAdministrationCostCalculator") {
        this.$router.push({
          name: "EstateAdministrationCostCalculatorContainer",
        });
      } else {
        this.$emit("gradientButtonClicked");
      }
    },
  },
  computed: {
    isMobile() {
      return this.$isMobileDevice();
    },
    accordion() {
      return this.activeTab === 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile-container {
  width: 100%;
  margin-top: 15px;
}
.mobile-section {
  width: 100%;
  .inner-content {
    border-top: 1px solid #dddddd;
    display: flex;
    flex-direction: column;

    .content-container {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .content-header {
      * {
        color: #282828;
      }
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 25px 0;
      .mobile-title {
        font-size: 16px !important;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0.5px;
      }
    }
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.3s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
  }
}

.content-image {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 95dvw;
}

.content-text {
  margin-top: 24px;
  .content-title {
    font-size: 28px;
    font-weight: 500;
    line-height: 34px;
    letter-spacing: -0.0025em;
  }

  .content-paragraphs {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.5px;
    margin-bottom: 20px;
  }
}

.easy-updates {
  margin-top: 60px;
}
.sub-content-button {
  margin-top: 60px;
}
</style>
